import { render, staticRenderFns } from "./ExpenseApportionmentComponent.vue?vue&type=template&id=86636756"
import script from "./ExpenseApportionmentComponent.vue?vue&type=script&lang=js"
export * from "./ExpenseApportionmentComponent.vue?vue&type=script&lang=js"
import style0 from "./ExpenseApportionmentComponent.vue?vue&type=style&index=0&id=86636756&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports